<template>
  <b-modal
    id="modal-renouvellement-form"
    size="xl"
    title="Indiquer un renouvellement"
    title-class="modal__title modal__title--edit"
    @ok="postRenouvellementAndUpdateParc"
    @cancel="resetRenouvellementForm"
  >
    <div class="parc-card-renouvellement-form">
      <!-- FORMULAIRE -->
      <div id="renouvellement-form">
        <b-form class="pt-2 px-md-3">

          <div class="alert alert-warning" role="alert" v-if="isSubstantielSelected">
            Merci de mettre à jour les caractéristiques/éoliennes/poste de livraison de votre parc en fonction des changements apportés par ce renouvellement.
          </div>

          <!-- Type de renouvellement -->
          <b-form-group
              label-cols-lg="3"
              label="Type de renouvellement"
              label-size="lg"
              label-class="fw-bold pt-0"
              class="mb-0"
          >
            <b-form-group
                id="input-group-types"
                label="Le parc a-t-il fait l'objet d'un renouvellement :"
                label-for="input-types"
                description="Veuillez sélectionner le type de renouvellement du parc"
            >
              <b-form-select
                  :options="renouvellementTypes"
                  v-model="selectedType"
                  @change="setRenouvellement"
              ></b-form-select>
            </b-form-group>
            <hr class="my-4" />
          </b-form-group>

          <!-- Dates d'autorisation remplacé par demande de la modification-->
          <b-form-group
              label-cols-lg="3"
              label="Dépôt du dossier de demande d'autorisation (ou du PC)"
              label-size="lg"
              label-class="fw-bold pt-0"
              class="mb-0"
              v-if="isSubstantielSelected"
          >
            <b-form-group
                id="input-group-dateDepotDemandeAutorisation"
                label="Date de dépôt du dossier de demande d'autorisation auprès de la DREAL ou date du permis de construire pour les parcs éoliens qui bénéficient de l'antériorité"
                label-for="input-dateDepotDemandeAutorisation"
            >
              <b-form-input
                  id="input-dateDepotDemandeAutorisation"
                  v-model="renouvellement.dateDepotDemandeAutorisation"
                  type="date"
                  :max="todayDate"
                  :state="validDateDepotDemandeAutorisation"
              >
              </b-form-input>
              <b-form-invalid-feedback v-if="!isDateDepotDemandeAutorisationFilled">
                La date de dépôt du dossier de demande d'autorisation (ou du PC) doit être renseignée
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!isDateDepotValid">
                La date ne doit pas être supérieure à la date du jour de la saisie
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-group>

          <!-- Avis de l'autorité environnementale -->
          <b-form-group
              label-cols-lg="3"
              label="Délivrance de l'avis de l'autorité environnementale"
              label-size="lg"
              label-class="fw-bold pt-0"
              class="mb-0"
              v-if="isSubstantielSelected"
          >
            <b-form-group
                id="input-group-dateDelivranceAvisAutoriteEnvironnementale"
                label="Date de délivrance de l'avis de l'autorité environnementale"
                label-for="input-dateDelivranceAvisAutoriteEnvironnementale"
                class="mb-4"
            >
              <b-form-input
                  id="input-dateDelivranceAvisAutoriteEnvironnementale"
                  v-model="renouvellement.dateDelivranceAvisAutoriteEnvironnementale"
                  type="date"
                  :max="todayDate"
                  :state="validDateDelivranceAvisAutoriteEnvironnementale"
              ></b-form-input>
              <b-form-invalid-feedback v-if="!isDateDepotDemandeAutorisationFilled">
                La date de dépôt du dossier de demande d'autorisation (ou du PC) doit être renseignée
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!isDateDelivranceAvisValid">
                La date ne doit pas être supérieure à la date du jour de la saisie
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!(renouvellement.dateDelivranceAvisAutoriteEnvironnementale >= renouvellement.dateDepotDemandeAutorisation)">
                Doit être supérieure à la date de dépôt du dossier de demande d'autorisation
                ({{ $filters.formatDate(renouvellement.dateDepotDemandeAutorisation) }})
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-group>

          <!-- Arrêté d'autorisation ICPE -->
          <b-form-group
              label-cols-lg="3"
              label="Arrêté d'autorisation ICPE"
              label-size="lg"
              label-class="fw-bold pt-0"
              class="mb-0"
              v-if="isSubstantielSelected"
          >
            <b-form-group
                id="input-group-dateDelivranceAutorisationIcpe"
                label="Arrêté d'autorisation ICPE"
                label-for="input-dateDelivranceAutorisationIcpe"
                class="mb-4"
            >
              <b-form-input
                  id="input-dateDelivranceAutorisationIcpe"
                  v-model="renouvellement.dateDelivranceAutorisationIcpe"
                  type="date"
                  :max="todayDate"
                  :state="validDateDelivranceAutorisationIcpe"
              ></b-form-input>
              <b-form-invalid-feedback v-if="!isDateDelivranceAvisAutoriteEnvironnementaleFilled">
                La date de délivrance de l'avis de l'autorité environnementale doit être renseignée
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!isDateDelivranceAutorisationIcpeValid">
                La date ne doit pas être supérieure à la date du jour de la saisie
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!(renouvellement.dateDelivranceAutorisationIcpe >= renouvellement.dateDelivranceAvisAutoriteEnvironnementale)">
                Doit être supérieure à la délivrance de l'avis de l'autorité environnementale
                ({{ $filters.formatDate(renouvellement.dateDelivranceAvisAutoriteEnvironnementale) }})
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-group>

          <!-- Déclaration d'ouverture du chantier de construction -->
          <b-form-group
              label-cols-lg="3"
              label="Déclaration d'ouverture du chantier de construction"
              label-size="lg"
              label-class="fw-bold pt-0"
              class="mb-0"
              v-if="isSubstantielSelected"
          >
            <b-form-group
                id="input-group-dateDeclarationOuvertureChantierConstruction"
                label="Déclaration d'ouverture du chantier de construction"
                label-for="input-dateDeclarationOuvertureChantierConstruction"
                class="mb-4"
            >
              <b-form-input
                  id="input-dateDeclarationOuvertureChantierConstruction"
                  v-model="renouvellement.dateDeclarationOuvertureChantierConstruction"
                  type="date"
                  :max="todayDate"
                  :state="validDateDeclarationOuvertureChantierConstruction"
              ></b-form-input>
              <b-form-invalid-feedback v-if="!isDateDelivranceAutorisationIcpeFilled">
                La date de l'arrêté d'autorisation ICPE doit être renseignée
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!isDateDeclarationOuvertureChantierValid">
                La date ne doit pas être supérieure à la date du jour de la saisie
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!(renouvellement.dateDeclarationOuvertureChantierConstruction >= renouvellement.dateDelivranceAutorisationIcpe)">
                Doit être supérieure à la date de délivrance de l'arrêté d'autorisation ICPE
                ({{ $filters.formatDate(renouvellement.dateDelivranceAutorisationIcpe) }})
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-group>

          <!-- Mise en service -->
          <b-form-group
              label-cols-lg="3"
              label="Mise en service"
              label-size="lg"
              label-class="fw-bold pt-0"
              class="mb-0"
              v-if="isSubstantielSelected"
          >
            <b-form-group
                id="input-group-dateMiseEnService"
                label="Mise en service"
                label-for="input-dateMiseEnService"
                class="mb-4"
            >
              <b-form-input
                  id="input-dateMiseEnService"
                  v-model="renouvellement.dateMiseEnService"
                  type="date"
                  :max="todayDate"
                  :state="validDateMiseEnService"
              ></b-form-input>
              <b-form-invalid-feedback v-if="!isDateDeclarationOuvertureChantierConstructionFilled">
                La date de l'arrêté d'autorisation ICPE doit être renseignée
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!isDateMiseEnServiceValid">
                La date ne doit pas être supérieure à la date du jour de la saisie
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!(renouvellement.dateMiseEnService >= renouvellement.dateDeclarationOuvertureChantierConstruction)">
                Doit être supérieure à la date de déclaration d'ouverture du chantier de construction
                ({{ $filters.formatDate(renouvellement.dateDeclarationOuvertureChantierConstruction) }})
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-group>

          <!-- Arrêté préfectoral complémentaire -->
          <b-form-group
              label-cols-lg="3"
              label="Arrêté préfectoral complémentaire"
              label-size="lg"
              label-class="fw-bold pt-0"
              class="mb-0"
              v-if="!isSubstantielSelected"
          >
            <b-form-group
                id="input-group-dateArretePrefectoralComplementaire"
                label="Date d'arrêté préfectoral complémentaire"
                label-for="input-dateArretePrefectoralComplementaire"
                class="mb-4"
            >
              <b-form-input
                  id="input-dateArretePrefectoralComplementaire"
                  v-model="renouvellement.dateArretePrefectoralComplementaire"
                  type="date"
                  :max="todayDate"
                  :state="validDateArretePrefectoralComplementaire"
              ></b-form-input>
              <b-form-invalid-feedback v-if="!isDateArretePrefectoralComplementaireFilled">
                La date de l'arrêté préfectoral complémentaire doit être renseignée
              </b-form-invalid-feedback>
              <b-form-invalid-feedback v-else-if="!isDateArretePrefectoralComplementaireValid">
                La date ne doit pas être supérieure à la date du jour de la saisie
              </b-form-invalid-feedback>
            </b-form-group>
          </b-form-group>
        </b-form>
      </div>
    </div>
    <template #footer="{ ok, cancel }">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button
        variant="info"
        id="save-renouvellement-form"
        @click="ok()"
        :disabled="disableSubitButtun"
      >
        Valider
        <b-tooltip target="#save-renouvellement-form">
          Veuillez renseigner toutes les dates pour valider le renouvellement
        </b-tooltip>
      </b-button>
      <b-button
        variant="default"
        id="cancel-renouvellement-form"
        @click="cancel()"
      >
        Annuler
        <b-tooltip target="#cancel-renouvellement-form">
          Revenir sur le panneau d'administration
        </b-tooltip>
      </b-button>
    </template>
  </b-modal>
</template>
<script setup>
import {
  BModal,
  BButton,
  BFormInput,
  BFormSelect,
  BFormInvalidFeedback,
  BFormGroup,
  BForm,
  BTooltip
} from "bootstrap-vue-next";
import {renouvellementService} from "@/service/renouvellement.service";
import {useReactiveStoreGetters, useStoreGetters} from "@/composables/useStore";
import {computed, onMounted, ref} from "vue";
import store from "@/store";
import {todayDate, isDateNotInFuture} from "@/util/date.util";

// Props
const { putParc, addNotification } = defineProps({
  putParc: Function,
  addNotification: Function,
})

// MapGetters from store
const {
  parc,
  isSubstantielRenouvellementType,
  isNotableRenouvellementType,
} = useStoreGetters([
  'parc',
  'isSubstantielRenouvellementType',
  'isNotableRenouvellementType',
]);
const { renouvellement } = useReactiveStoreGetters(['renouvellement']);

// Data
const selectedType = ref("Substantiel");
const renouvellementTypes = ["Substantiel", "Notable"];
const parcId = ref(null);

// Computed properties
const isSubstantielSelected = computed(() => selectedType.value === "Substantiel");
const isDateArretePrefectoralComplementaireFilled =
    computed(() => !!renouvellement.value.dateArretePrefectoralComplementaire);
const isDateDepotDemandeAutorisationFilled = computed(() => !!renouvellement.value.dateDepotDemandeAutorisation);
const isDateDelivranceAvisAutoriteEnvironnementaleFilled = computed(() => !!renouvellement.value.dateDelivranceAvisAutoriteEnvironnementale);
const isDateDelivranceAutorisationIcpeFilled = computed(() => !!renouvellement.value.dateDelivranceAutorisationIcpe);
const isDateDeclarationOuvertureChantierConstructionFilled = computed(() => !!renouvellement.value.dateDeclarationOuvertureChantierConstruction);
const isDateMiseEnServiceFilled = computed(() => !!renouvellement.value.dateMiseEnService);

const isDateDepotValid = computed(() => isDateNotInFuture(renouvellement.value.dateDepotDemandeAutorisation));
const isDateDelivranceAvisValid = computed(() => isDateNotInFuture(renouvellement.value.dateDelivranceAvisAutoriteEnvironnementale));
const isDateDelivranceAutorisationIcpeValid = computed(() => isDateNotInFuture(renouvellement.value.dateDelivranceAutorisationIcpe));
const isDateDeclarationOuvertureChantierValid = computed(() => isDateNotInFuture(renouvellement.value.dateDeclarationOuvertureChantierConstruction));
const isDateMiseEnServiceValid = computed(() => isDateNotInFuture(renouvellement.value.dateMiseEnService));
const isDateArretePrefectoralComplementaireValid = computed(() => isDateNotInFuture(renouvellement.value.dateArretePrefectoralComplementaire));

const validDateDepotDemandeAutorisation = computed(() => {
  if (!isDateDepotDemandeAutorisationFilled.value) {
    return null;
  }
  return isDateDepotValid.value;
});
const validDateDelivranceAvisAutoriteEnvironnementale = computed(() => {
  if (!isDateDelivranceAvisAutoriteEnvironnementaleFilled.value) {
    return null;
  }
  return isDateDelivranceAvisValid.value && isDateDepotDemandeAutorisationFilled.value && renouvellement.value.dateDelivranceAvisAutoriteEnvironnementale >= renouvellement.value.dateDepotDemandeAutorisation;
});
const validDateDelivranceAutorisationIcpe = computed(() => {
  if (!isDateDelivranceAutorisationIcpeFilled.value) {
    return null;
  }
  return isDateDelivranceAutorisationIcpeValid.value && isDateDelivranceAvisAutoriteEnvironnementaleFilled.value && renouvellement.value.dateDelivranceAutorisationIcpe >= renouvellement.value.dateDelivranceAvisAutoriteEnvironnementale;
});
const validDateDeclarationOuvertureChantierConstruction = computed(() => {
  if (!isDateDeclarationOuvertureChantierConstructionFilled.value) {
    return null;
  }
  return isDateDeclarationOuvertureChantierValid.value && isDateDelivranceAutorisationIcpeFilled.value && renouvellement.value.dateDeclarationOuvertureChantierConstruction >= renouvellement.value.dateDelivranceAutorisationIcpe;
});
const validDateMiseEnService = computed(() => {
  if (!isDateMiseEnServiceFilled.value) {
    return null;
  }
  return isDateMiseEnServiceValid.value && isDateDeclarationOuvertureChantierConstructionFilled.value && renouvellement.value.dateMiseEnService >= renouvellement.value.dateDeclarationOuvertureChantierConstruction;
});

const validDateArretePrefectoralComplementaire = computed(() => {
  if (!isDateArretePrefectoralComplementaireFilled.value) {
    return null;
  }
  return isDateArretePrefectoralComplementaireValid.value;
});
const disableSubitButtun = computed(() => {
  if (isSubstantielSelected.value) {
    return (
        validDateDepotDemandeAutorisation.value === false ||
        validDateDelivranceAvisAutoriteEnvironnementale.value === false ||
        validDateDelivranceAutorisationIcpe.value === false ||
        validDateDeclarationOuvertureChantierConstruction.value === false ||
        validDateMiseEnService.value === false
    );
  } else {
    return validDateArretePrefectoralComplementaire.value === false;
  }
});

// Methods
const postRenouvellementAndUpdateParc = async () => {
  parc.renouvellement = true;
  if (isSubstantielRenouvellementType) {
    parc.renouvellementSubstantiel = true;
  } else if (isNotableRenouvellementType) {
    parc.renouvellementNotable = true;
  }

  await postRenouvellement();
};

const postRenouvellement = async () => {
  try {
    const response = await renouvellementService.postRenouvellement(renouvellement.value)
    addNotification(response);
    await putParc();
  } catch (err) {
    console.log(err);
  }

  resetRenouvellementForm();
};

const setRenouvellement = () => {
  renouvellement.value.dateRenouvellement = new Date();
  renouvellement.value.parc = { id: parcId.value };
  renouvellement.value.type = isSubstantielSelected.value ? 'S' : 'N';

  store.dispatch('saveRenouvellement', renouvellement.value);
};

// Created
onMounted(() => {
  parcId.value = store.getters.parc.id;
  setRenouvellement();
});

const resetRenouvellementForm = () => {
  store.dispatch('saveRenouvellement', { parc: { id: parcId.value }, type: isSubstantielSelected.value ? 'S' : 'N', dateRenouvellement: new Date() });
}

</script>
<style lang="scss">
.parc-card-renouvellement-form  {
  .form-control {
    border: #ced4da 1px solid;
  }
}
</style>

